import { CSSProperties } from "react";
import styled from "styled-components";
import Box from "./Box";
import { AiFillExclamationCircle } from "react-icons/ai" ;
interface IProps {
  title?: string;
  value?: any;
  valueStyle?: CSSProperties;
  titleStyle?: CSSProperties;
  style?: CSSProperties;
}

const Statistic = (props: IProps) => {
  const {
    title = "",
    value = "",
    valueStyle = {},
    titleStyle = {},
    style = {},
  } = props;

  return (
    <Box p={2} backgroundColor={"white"} style={style}>
      <Box display="flex" flexDirection="row" alignItems="center" color="muted">
        <Title mr={1} style={titleStyle}>
          {title}
        </Title>
        <AiFillExclamationCircle />
      </Box>
      <Value style={valueStyle}>{value}</Value>
    </Box>
  );
};

export default Statistic;

const Title = styled(Box)({
  fontSize: 14,
});

const Value = styled("div")({
  marginTop: 8,
  fontWeight: 500,
});
